var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFastFood = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fast-Food-Burger-Drink--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fast Food Burger Drink Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 12h-6a4 4 0 0 0 -4 3.43 0.49 0.49 0 0 0 0.12 0.4 0.49 0.49 0 0 0 0.38 0.17h12.96a0.49 0.49 0 0 0 0.38 -0.17 0.49 0.49 0 0 0 0.12 -0.4A4 4 0 0 0 19 12Zm-5.75 2.5a0.75 0.75 0 1 1 0.75 -0.75 0.76 0.76 0 0 1 -0.75 0.75ZM16 15a0.75 0.75 0 1 1 0.75 -0.75 0.76 0.76 0 0 1 -0.75 0.75Zm2.75 -0.5a0.75 0.75 0 1 1 0.75 -0.75 0.76 0.76 0 0 1 -0.75 0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19a1.5 1.5 0 0 1 -1.5 1.5h-13A1.5 1.5 0 0 1 8 19a1.5 1.5 0 0 1 1.5 -1.5h13A1.5 1.5 0 0 1 24 19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.41 22a0.49 0.49 0 0 1 0.41 0.21 0.5 0.5 0 0 1 0.07 0.46A2 2 0 0 1 21 24H11a2 2 0 0 1 -1.89 -1.33 0.5 0.5 0 0 1 0.07 -0.46 0.49 0.49 0 0 1 0.41 -0.21Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.68a1.48 1.48 0 0 0 -0.37 -1.17A1.46 1.46 0 0 0 12.5 6h-4a0.5 0.5 0 0 1 -0.38 -0.17 0.47 0.47 0 0 1 -0.12 -0.38l0.31 -2.91a0.49 0.49 0 0 1 0.2 -0.35 0.53 0.53 0 0 1 0.39 -0.09l3.9 0.75a1 1 0 0 0 0.38 -2L8.75 0a2 2 0 0 0 -2.36 1.79L6 5.55a0.51 0.51 0 0 1 -0.5 0.45h-4a1.5 1.5 0 0 0 -1.13 0.51A1.52 1.52 0 0 0 0 7.69l1.88 15A1.49 1.49 0 0 0 3.37 24h3.38a0.5 0.5 0 0 0 0.5 -0.5v-1a0.5 0.5 0 0 0 -0.5 -0.5H4.26a0.51 0.51 0 0 1 -0.5 -0.44l-1.62 -13a0.47 0.47 0 0 1 0.12 -0.39 0.48 0.48 0 0 1 0.37 -0.17h2.54a0.5 0.5 0 0 1 0.37 0.17 0.52 0.52 0 0 1 0.13 0.38L4.51 19.39a1 1 0 0 0 2 0.22L7.69 8.45A0.49 0.49 0 0 1 8.18 8h3.19a0.48 0.48 0 0 1 0.37 0.17 0.47 0.47 0 0 1 0.12 0.39l-0.14 1.13a0.51 0.51 0 0 0 0.12 0.39 0.52 0.52 0 0 0 0.38 0.17h1a0.5 0.5 0 0 0 0.49 -0.44Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFastFood);
export default ForwardRef;